import React, { useEffect, useState, useCallback } from 'react';
import useFirebase from './context';
import { useUpgrade } from '../Dialog/useUpgrade';
import { useAuthentication } from '../Session';
import { useNotification } from '../Notification/useNotification';

const PREMIUM_CONTINGENT_SECONDS = 18000;
const FREE_TIER_CONTINGENT_SECONDS = 3600;

const useContingent = () => {
  const firebase = useFirebase();
  const upgrade = useUpgrade();
  const authUser = useAuthentication();
  const notification = useNotification();
  const [contingent, setContingent] = useState(0);
  const [plan, setPlan] = useState('free');
  const [maxContingent, setMaxContingent] = useState(0);

  useEffect(() => {
    console.debug('loading contingent data now');
    firebase
      .user(authUser.uid)
      .get()
      .then(doc => {
        let user = doc.data();
        setPlan(user.plan);
        console.log('finished loading user data');
      });
    firebase.contingent(authUser.uid).onSnapshot(snapshot => {
      if (snapshot.empty) {
        console.debug('contingent doesnt exist, hence contingent is 0');
        setContingent(0);
      } else {
        console.debug('contingent retrieved', snapshot.docs);
        let contingentData = snapshot.docs.reduce(
          (accu, curr) => accu + curr.data().length,
          0
        );
        setContingent(contingentData);
      }
    });
  }, [firebase, authUser]);

  useEffect(() => {
    setMaxContingent(
      plan === 'premium'
        ? PREMIUM_CONTINGENT_SECONDS
        : FREE_TIER_CONTINGENT_SECONDS
    ); // 1 hr for free, 5hrs for premium
  }, [plan]);

  const getPercentageUsed = useCallback(
    () => (contingent / maxContingent) * 100,
    [contingent, maxContingent]
  );

  const getRemaining = useCallback(() => maxContingent - contingent, [
    contingent,
    maxContingent
  ]);

  const handleUpgrade = () => {
    console.debug('handling upgrade now');
    return (
      upgrade()
        // add upgrade Request
        .then(() => firebase.upgradeRequest(authUser.uid))
        // add analytics event
        .then(() => firebase.logEvent('upgrade'))
        // send notification
        .then(() => {
          notification({
            description:
              'Successfully sent the upgrade request. We will come back to you.',
            variant: 'success'
          });
        })
        .catch(e => {
          console.error(e);
        })
    );
  };

  return {
    contingent,
    getPercentageUsed,
    getRemaining,
    handleUpgrade
  };
};

export default useContingent;
